export default () => {
  return {
    content: "UEsDBBQAAAAIAKg5BFdGWsEMggAAALEAAAAQAAAAZG9jUHJvc",
    error: false,
    filename: "report_1970-01-01_2023-08-04.xlsx",
  };
};
